import React from "react";
import "./Agents.css";
import AgentIcon from "../assets/Icons/agent.svg";
import DealPriceIcon from "../assets/Icons/dealprice.svg";
import { Avatar, MenuItem, TextField } from "@mui/material";
import { stringAvatar } from "../../../helpers/stringAvatar";
import Autocomplete from "@mui/material/Autocomplete";
import { useState } from "react";

import { getAuth } from "firebase/auth";
import GetAdmin from "../../../controllers/Enquiries/GetAdmin";
import { useEffect } from "react";
import GetAllAgents from "../../../controllers/agents/GetAllAgents";
import getSettings from "../../../controllers/settings/getSettings";
import FormatPriceNumeral from "../../../helpers/FormatPriceNumeral";
import FormatPriceVerbal from "../../../helpers/FormatPriceVerbal";

const Agents = ({
  agent,
  setAgent,
  dealPrice,
  setDealPrice,
  isAgentError,
  isUpdate,
  isBtnDisable,
}) => {
  const [open, setOpen] = useState(true);
  const [allAgents, setAllAgents] = useState([]);

  const [mCurrencySettings, setMCurrencySettings] = useState({});

  useEffect(() => {
    async function fetchData() {
      const settings = await getSettings();
      setMCurrencySettings(settings);
    }
    fetchData();
  }, []);

  // Agents useEffect Start
  useEffect(() => {
    if (isUpdate) {
      setAgent(agent);
    } else {
      setDealPrice();
    }
    async function fetchData() {
      const agentsData = (await GetAllAgents("*", "newest", "*", 100)).agents;

      const { uid } = getAuth().currentUser;

      let adminData = await GetAdmin();
      adminData = { ...adminData, id: adminData.uid };

      agentsData.unshift(adminData);
      if (isUpdate === false) {
        setAgent(adminData);
      }
      //

      setAllAgents(agentsData);
    }

    fetchData();
  }, []);
  // Agents useEffect End

  return (
    <div
      className={`add-deal-card agent-card ${
        isBtnDisable === true && "custom-disable-card"
      }`}
    >
      <div className="active-status">
        {/* <img src={CheckIcon} alt="landbook" /> */}
      </div>
      <div className="card-content">
        <div className="card-agent-select">
          <div className="img-label-container">
            <div>
              <img src={AgentIcon} alt="img" />
            </div>
            <div>
              <h2 className="add-agent-label">Agents</h2>
            </div>
          </div>

          <Autocomplete
            // open={open}
            // onOpen={() => setOpen(true)}
            // onClose={() => setOpen(false)}
            id="tags-outlined"
            options={allAgents}
            // sx={{ width: 300 }}

            value={agent}
            autoHighlight={true}
            Agent
            getOptionLabel={(option) => option.name ?? ""}
            onChange={(event, value, reason, details) => {
              if (isBtnDisable === false) {
                if (value === null) {
                  setAgent({});
                  return;
                }

                setAgent(value);
              }
            }}
            renderOption={(props, option) => (
              <MenuItem {...props} id={option.id}>
                {
                  <div className="add-deal-agent-dropdown">
                    <Avatar
                      className="add-deal-agent-dropdown-avatar"
                      {...stringAvatar(option.name)}
                    />
                    <div className="agent-dropdown-right-side-details">
                      <div className="add-deal-agent-dropdown-name">
                        {option.name}
                      </div>
                      <div className="add-deal-agent-dropdown-phone">
                        {option.phoneNumber}
                      </div>
                    </div>
                  </div>
                }
              </MenuItem>
            )}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  label="Select an agent"
                  size="small"
                  error={isAgentError ? true : false}
                  InputLabelProps={{
                    style: {
                      color: "rgba(100,100,100,.4)",
                    },
                  }}
                />
              );
            }}
          />
        </div>
        <div className="price-select">
          <div className="img-label-container">
            <div>
              <img src={DealPriceIcon} alt="img" />
            </div>
            <div>
              <h2 className="add-agent-label">
                Deal Price
                <span style={{ color: "grey", fontSize: 15 }}>
                  (
                  {mCurrencySettings.currencyFormat === "numeral"
                    ? dealPrice > 0
                      ? FormatPriceNumeral(dealPrice)
                      : dealPrice
                    : dealPrice > 0
                    ? FormatPriceVerbal(dealPrice)
                    : FormatPriceVerbal(dealPrice)}
                  {dealPrice && " " + mCurrencySettings?.currency})
                </span>
              </h2>
            </div>
          </div>
          <input
            value={dealPrice}
            onChange={(e) => {
              if (isBtnDisable === false) {
                const re = /^-?\d*$/;

                if (re.test((e.target.value = e.target.value.slice(0, 10)))) {
                  setDealPrice(e.target.value);
                }
              }
            }}
            type="number"
            maxLength={"12"}
            min={0}
            pattern={/^-?\d*$/}
            // className="deal-price-input"
            className="deal-price-input form-input-field"
          />
        </div>
      </div>
    </div>
  );
};

export default Agents;
